/*
 * @Author: kim
 * @Date: 2022-06-07 23:21:16
 * @Description: 合作伙伴
 */
import { FunctionalComponent, h } from "preact";
import LazyLoad from "react-lazyload";
// import * as style from "./style.less"
import "./style.less";

interface Props {
  //wrapperClassName?: string;
}

const PartnersView: FunctionalComponent<Props> = (props: Props) => {
  //const { wrapperClassName } = props;

  return (
    <section class={`partnersView`}>
      <LazyLoad height={504} once>
        <img
          class="bg"
          alt="合作伙伴背景"
          title="合作伙伴"
          src="//rmt-oss.zaker.cn/yiqijian_images/partners-bg.jpg"
        />
      </LazyLoad>
      <p class="title">成为一起剪的战略合作伙伴</p>
      <p class="title addPadding">让价值资讯传递得更快</p>
      <div class="box">
        {/* href='http://www.ycwb.com/' target="_blank"  */}
        <div class="item" title="羊城晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="21世纪经济报道"
              title="21世纪经济报道"
              src="//rmt-oss.zaker.cn/yiqijian_images/logo_21cn.png"
            />
          </LazyLoad>
        </div>
        {/* href='http://www.ycwb.com/' target="_blank"  */}
        <div class="item" title="羊城晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="羊城晚报"
              title="羊城晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/yangcheng.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://xdkb.net/" target="_blank"  */}
        <div class="item" title="现代快报">
          <LazyLoad once>
            <img
              class="logo"
              alt="现代快报"
              title="现代快报"
              src="//rmt-oss.zaker.cn/yiqijian_images/xiandai.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://wb.sznews.com/PC/layout/201908/27/node_A01.html" target="_blank"  */}
        <div class="item" title="深圳晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="深圳晚报"
              title="深圳晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/shenzhen.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.jnds.com.cn/" target="_blank"  */}
        <div class="item" title="江南都市">
          <LazyLoad once>
            <img
              class="logo"
              alt="江南都市"
              title="江南都市"
              src="//rmt-oss.zaker.cn/yiqijian_images/jiangnan.png"
            />
          </LazyLoad>
        </div>
        {/* href="https://www.dahe.cn/" target="_blank"  */}
        <div class="item" title="今日消费">
          <LazyLoad once>
            <img
              class="logo"
              alt="今日消费"
              title="今日消费"
              src="//rmt-oss.zaker.cn/yiqijian_images/jinri.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.nnnews.net/" target="_blank"  */}
        <div class="item" title="南宁晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="南宁晚报"
              title="南宁晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/nanning.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.xkb.com.cn/" target="_blank"  */}
        <div class="item" title="新快报">
          <LazyLoad once>
            <img
              class="logo"
              alt="新快报"
              title="新快报"
              src="//rmt-oss.zaker.cn/yiqijian_images/xinkuaibao.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.my399.com/" target="_blank"  */}
        <div class="item" title="新晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="新晚报"
              title="新晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/xinwanbao.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.lnd.com.cn/" target="_blank"  */}
        <div class="item" title="辽沈晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="辽沈晚报"
              title="辽沈晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/liaoshen.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://epaper.heyuan.cn/html/2019-08/27/node_1.htm" target="_blank"  */}
        <div class="item" title="河源日报">
          <LazyLoad once>
            <img
              class="logo"
              alt="河源日报"
              title="河源日报"
              src="///rmt-oss.zaker.cn/yiqijian_images/heyuan.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.gywb.cn/" target="_blank"  */}
        <div class="item" title="贵阳晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="贵阳晚报"
              title="贵阳晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/guiyang.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.sjzdaily.com.cn/" target="_blank"  */}
        <div class="item" title="燕赵晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="燕赵晚报"
              title="燕赵晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/yanzhao.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.sunnews.cn/" target="_blank"  */}
        <div class="item" title="海西晨报">
          <LazyLoad once>
            <img
              class="logo"
              alt="海西晨报"
              title="海西晨报"
              src="//rmt-oss.zaker.cn/yiqijian_images/haixi.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.hilizi.com/" target="_blank"  */}
        <div class="item" title="半岛晨报">
          <LazyLoad once>
            <img
              class="logo"
              alt="半岛晨报"
              title="半岛晨报"
              src="//rmt-oss.zaker.cn/yiqijian_images/bandao.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.qhdnews.com/" target="_blank"  */}
        <div class="item" title="秦皇岛日报">
          <LazyLoad once>
            <img
              class="logo"
              alt="秦皇岛日报"
              title="秦皇岛日报"
              src="//rmt-oss.zaker.cn/yiqijian_images/qinhuangdao.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.hf365.com/" target="_blank"  */}
        <div class="item" title="合肥晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="合肥晚报"
              title="合肥晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/hefei.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.bdall.com/" target="_blank"  */}
        <div class="item" title="保定晚报">
          <LazyLoad once>
            <img
              class="logo"
              alt="保定晚报"
              title="保定晚报"
              src="//rmt-oss.zaker.cn/yiqijian_images/baoding.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.xxcb.cn/" target="_blank"  */}
        <div class="item" title="潇湘晨报">
          <LazyLoad once>
            <img
              class="logo"
              alt="潇湘晨报"
              title="潇湘晨报"
              src="//rmt-oss.zaker.cn/yiqijian_images/xiaoxiang.png"
            />
          </LazyLoad>
        </div>
        {/* href="http://www.xxcb.cn/" target="_blank"  */}
        <div class="item" title="泰安传媒集团">
          <LazyLoad once>
            <img
              class="logo"
              alt="泰安传媒集团"
              title="泰安传媒集团"
              src="//rmt-oss.zaker.cn/yiqijian_images/taian.png"
            />
          </LazyLoad>
        </div>
        {/* href="#" target="_blank"  */}
        <div class="item" title="珠海广播电视台">
          <LazyLoad once>
            <img
              class="logo"
              alt="珠海广播电视台"
              title="珠海广播电视台"
              src="//rmt-oss.zaker.cn/yiqijian_images/zhuhai.png"
            />
          </LazyLoad>
        </div>
        {/* href="#" target="_blank"  */}
        {/* <div class="item" title="ZAKER湖北">
          <LazyLoad once>
            <img
              class="logo"
              alt="ZAKER湖北"
              title="ZAKER湖北"
              src="//zkvideo-oss.myzaker.com/yiqijian/images/partners/hubei.png"
            />
          </LazyLoad>
        </div> */}
        {/* href="http://www.xwh.cn/" target="_blank"  */}
        <div class="item" title="新文化报">
          <LazyLoad once>
            <img
              class="logo"
              alt="新文化报"
              title="新文化报"
              src="//rmt-oss.zaker.cn/yiqijian_images/xinwenhua.png"
            />
          </LazyLoad>
        </div>
        {/* href="#" target="_blank"  */}
        {/* <div class="item" title="ZAKER无锡">
          <LazyLoad once>
            <img
              class="logo"
              alt="ZAKER无锡"
              title="ZAKER无锡"
              src="//zkvideo-oss.myzaker.com/yiqijian/images/partners/wuxi.png"
            />
          </LazyLoad>
        </div> */}
        {/* href="http://www.lzbs.com.cn/" target="_blank"  */}
        <div class="item" title="兰州日报">
          <LazyLoad once>
            <img
              class="logo"
              alt="兰州日报"
              title="兰州日报"
              src="//rmt-oss.zaker.cn/yiqijian_images/lanzhou.png"
            />
          </LazyLoad>
        </div>
      </div>
    </section>
  );
};

export default PartnersView;
